const InfoIcon = () => (
    <svg className="h-5 w-5 text-[#1f94c2] mt-0.5 shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
    </svg>
);

export const SignatureInstructionsPanel = ({ title = '¿Cómo firmar digitalmente?' }) => (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <div className="flex items-start gap-3">
            <InfoIcon />
            <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-[#205087] mb-2">{title}</h4>
                <div className="text-sm text-blue-900 space-y-1.5">
                    <p>
                        <strong>1.</strong> Mantén presionado el clic (mouse) o el dedo (pantalla táctil) sobre el recuadro blanco.
                    </p>
                    <p>
                        <strong>2.</strong> Sin soltar, arrastra para dibujar tu firma como lo harías en papel.
                    </p>
                    <p>
                        <strong>3.</strong> Si no te gusta el resultado, usa <strong>Limpiar firma</strong> e intenta de nuevo.
                    </p>
                    <p>
                        <strong>4.</strong> Cuando estés conforme, presiona <strong>Firmar contrato</strong>.
                    </p>
                </div>
            </div>
        </div>
    </div>
);

export const SignatureHelpModal = ({ isOpen, onClose, title = 'Instrucciones para firmar' }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[10001] flex items-center justify-center p-4 bg-black/50"
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div
                className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="signature-help-title"
            >
                <div className="flex items-start gap-3 mb-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 shrink-0">
                        <InfoIcon />
                    </div>
                    <div>
                        <h3 id="signature-help-title" className="text-lg font-bold text-[#205087]">
                            {title}
                        </h3>
                        <p className="text-sm text-gray-600 mt-1">
                            Sigue estos pasos antes de firmar en el recuadro.
                        </p>
                    </div>
                </div>

                <ol className="text-sm text-gray-700 space-y-3 mb-6 list-decimal list-inside">
                    <li>
                        <strong>Mantén presionado el clic</strong> (mouse) o <strong>el dedo</strong> (pantalla táctil) sobre el recuadro blanco.
                    </li>
                    <li>
                        Sin soltar, <strong>arrastra</strong> para dibujar tu firma como lo harías en papel.
                    </li>
                    <li>
                        Si no te gusta el resultado, usa <strong>Limpiar firma</strong> e intenta de nuevo.
                    </li>
                    <li>
                        Cuando estés conforme, presiona <strong>Firmar contrato</strong>.
                    </li>
                </ol>

                <button
                    type="button"
                    onClick={onClose}
                    className="w-full py-3 px-4 bg-[#1f94c2] hover:bg-[#205087] text-white font-semibold rounded-lg transition-colors"
                >
                    Entendido, continuar →
                </button>
            </div>
        </div>
    );
};
